export const applications = [
    {name: 'LumiData', url: 'https://lumidata.com', icon: 'ft-database item-badge mb-4'},
    {name: 'LumiBackOffice', url: 'https://lumibackoffice.com', icon: 'ft-activity item-badge mb-4'},
    {name: 'LumiBridge', url: 'https://lumibridge.com', icon: 'ft-globe item-badge mb-4'},
    {name: 'LumiFlow', url: 'https://lumiflow.com', icon: 'ft-layers item-badge mb-4'}
]